export const PAGE_PERMISSIONS = {
  "/AddItems": "page:products",
  "/AddSalesItems": "page:products",

  "/categories_management": "page:categories",
  "/updatesubcategory": "page:categories",

  "/orderlist": "page:orders",
  "/downloadbill": "page:orders",

  "/riderregistration": "page:riders",
  "/riderlist": "page:riders",
  "/addtransaction": "page:rider_transactions",

  "/scanorder": "page:scan_orders",

  "/hotspot": "page:hotspots",
  "/RadiusMap": "page:radius",

  "/banner_management": "page:banners",

  "/coupon_management": "page:coupons",
  "/promocode": "page:coupons",
  "/referralcode": "page:referrals",

  "/pushNotification": "page:push",

  "/report": "page:reports",
  "/leaderboard": "page:reports",

  "/questions": "page:questions",

  "/certificate/dashboard": "page:certificates",
  "/certificate/create": "page:certificates",

  "/__admin_dev": "page:users"
};